import React from 'react';


const NotFound = () => (
  <div className="info_none">
    <div className="txt_none">
      검색 결과가 없습니다.
    </div>
  </div>
);

export default NotFound;
